export const TRANSLATION_NAMESPACE = 'createLessonModalV2';
export const MODAL_HEIGHT = '450px';
export const MODAL_WIDTH = '600px';
